module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput),
      expression: "currentInput"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.question.commited && _vm.question.correct && _vm.paid) ? _c('div', {
    staticClass: "congratulations"
  }, [_vm._v("\n    Your answer is correct!\n  ")]) : _vm._e(), _vm._v(" "), (_vm.question.commited && !_vm.question.correct && _vm.paid) ? _c('div', {
    staticClass: "sorry"
  }, [_vm._v("\n    Your answer is incorrect. You Entered " + _vm._s(_vm.question.userAnswer) + ". Correct answer is " + _vm._s(_vm.question.answers_input) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.question.commited && !_vm.paid) ? _c('div', [_vm._v("Answer submitted. Click Continue to proceed.")]) : _vm._e(), _vm._v(" "), (!_vm.question.commited) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.answerInput(_vm.question)
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1451d6db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/QuizModels/InputAnswer.vue
// module id = 41
// module chunks = 0